import { Component, OnInit, Input } from '@angular/core';
import { DateTimeUtil } from 'src/app/core/framework/utils/date-time-util';

import { IdadeUtil } from 'src/app/core/framework/utils/idade-util';
import { MascaraUtil } from 'src/app/core/framework/utils/mascara-util';
import { Paciente } from 'src/app/homecare/paciente/paciente.model';


@Component({
  selector: 'app-topbar-search-item-resultado',
  templateUrl: './topbar-search-item-resultado.component.html',
  styleUrls: ['./topbar-search-item-resultado.component.css']
})
export class TopbarSearchItemResultadoComponent implements OnInit {

  @Input() paciente: Paciente = null;
  @Input() index: number;
  @Input() activeIndex: number = 0;

  public idade = '';
  public dataNascimento = '';
  public cpf = '';

  private idadeUtil = new IdadeUtil();
  private dateTimeUtil = new DateTimeUtil();


  constructor() { }

  ngOnInit(): void {
    const _dataNascimento = new Date(this.paciente.dataNascimento);
    this.idade = this.idadeUtil.getIdadeDescritiva(_dataNascimento);
    this.dataNascimento = this.dateTimeUtil.dateToDiaMesAno(_dataNascimento);
    
    if ( this.paciente.cpf ) {
      this.cpf = MascaraUtil.mascaraDeCPF(this.paciente.cpf);
    }
  }

}
